import styled from 'styled-components';

export const WrapperLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
